import { render, staticRenderFns } from "./ArticleDefaultsForm.vue?vue&type=template&id=9e7f6e58"
import script from "./ArticleDefaultsForm.vue?vue&type=script&lang=ts"
export * from "./ArticleDefaultsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports